export default __webpack_public_path__ + "static/media/banner-site-agencias.ae9d8cdc.png";